<template>
    <div id="app">
        <v-app id="inspire">
            <v-img dark class="blue" height="200">
                <v-container>
                    <v-layout>
                        <v-container>
                            <v-flex xs6 right>
                            <v-text-field solo flat hide-details label="Search" v-model="search" append-icon="search" clearable></v-text-field>
                            </v-flex>
                        </v-container>
                    </v-layout>

                    <v-layout v-if="approver.includes(level)" xs12>
                        <v-container class="p-2 pb-0">
                            <v-flex xs6 right>
                                <v-btn color="red accent-4" dark @click="showPending=true"> Pending For Approval </v-btn>
                            </v-flex>
                        </v-container>
                    </v-layout>
                </v-container>
            </v-img>

            <v-container fluid grid-list-md> 
                <v-layout row wrap>
                    <v-flex xs12 sm12 md8 lg8>
                    <v-container>
                        <v-data-table :headers="headers" :items="lists" :search="search">
                            <template v-slot:items="props">
                                <td>{{ props.item.event }}</td>
                                <td class="text-xs-left">{{ props.item.date }}</td>
                                <td class="text-xs-center">{{ props.item.From}}<br>{{ props.item.To}}</td>
                                <td class="text-xs-left">{{ props.item.remarks }}</td>
                                <td class="text-xs-left text-capitalize">{{ props.item.status }}</td>
                            </template> 
                            <template v-slot:no-data>
                                <v-alert :value="true" color="grey">
                                    No Events Available
                                </v-alert>
                            </template>

                            <template v-slot:no-results>
                                <v-alert :value="true" color="error" icon="warning">
                                    Your search for "{{ search }}" found no results.
                                </v-alert>
                            </template>
                        </v-data-table>
                        </v-card>
                    </v-container>
                    </v-flex>
                    <v-flex xs12 sm12 md4 lg4>
                        <v-layout row wrap class="pt-3">
                            <v-flex xs12>
                            <v-text-field label="Event*" v-model="event" color="primary" outline required></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field outline  readonly  @click="selectdate=true" label="Date*" required :value="computedDateFormattedMomentjs"
                                ></v-text-field>

                                <v-dialog ref="dialog" persistent lazy full-width width="290px" v-model="selectdate" >
                                    <v-date-picker v-model="maindate" :allowed-dates="allowedDates" :min="date" scrollable @input="selectdate = false">
                                        <v-spacer></v-spacer>
                                    </v-date-picker>
                                </v-dialog>
                            </v-flex>

                            <v-flex xs12>
                                <h3 class="subheading transparent font-weight-medium justify-center">Time
                                </h3>
                            </v-flex>

                            <v-flex xs6 sm6 md4 lg6>
                                <v-select label="From*" v-model="timeFrom" outline :items="time.from" required></v-select>
                            </v-flex>
                        
                            <v-flex xs6>
                                <v-select label="To*" v-model="timeTo" :items="time.to" outline required></v-select>
                            </v-flex>

                            <v-flex xs12 class="pb-3">
                                <v-select v-model="remarks" outline label="Reason/Remarks*" required :items="reasons" hide-details
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 class="pt-0 justify-center">
                                <v-btn @click="clear()" color="red accent-4" dark> Clear</v-btn>
                                <v-btn color="blue darken-4" dark @click="(setAdminCalendar())">Save</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-dialog v-model="showPending" persistent>
                <v-toolbar dark color="blue-grey darken-3">
                    <v-btn icon dark @click="showPending=false">
                    <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>For Approval</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card>
                    <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 class="pr-0">         
                            <v-data-table :headers="forApprovalHeader"
                            :items="forApproval" item-key="Id" class="elevation-1">
                                <template v-slot:items="props">
                                    <td>{{ props.item.event }}</td>
                                    <td class="text-xs-left">{{ props.item.date }}</td>
                                    <td class="text-xs-center">{{ props.item.From}}<br>{{ props.item.To}}</td>
                                    <td class="text-xs-left">{{ props.item.remarks }}</td>
                                    <td class="text-xs-left">{{ props.item.status }}</td>
                                    <td class="text-xs-left">{{ props.item.requester }}</td>
                                    <td class="text-xs-left">{{ props.item.createdDate }}</td>
                                    <td>
                                        <v-layout>
                                            <v-btn small color="red accent-4" @click="decision(props.item,'rejected')" dark>Reject</v-btn>
                                            <v-btn small color="green darken-4" @click="decision(props.item,'approved')" dark>Approve</v-btn>
                                        </v-layout>
                                    </td>
                                </template> 

                                <template v-slot:no-data>
                                    <v-alert :value="true" color="grey">
                                        No Pending for Approval
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-flex> 
                    </v-layout>
                    </v-container>
                </v-card>
            </v-dialog>

            <v-dialog v-model="decisionDialog" max-width="500px" persistent>
                <v-card>
                    <v-parallax dark class="blue-grey darken-3 pb-0" height="80">
                        <v-spacer></v-spacer>
                        <v-container>
                            <v-layout><br>
                            <h4 class="title font-weight-medium">{{decisionTitle}}</h4>
                            </v-layout>
                        </v-container>
                    </v-parallax>

                    <v-container grid-list>
                        <v-card-text class="subheading font-weight-regular">
                        {{decisionBody}}
                        </v-card-text>
                        <v-card-text class="subheading font-weight-regular">
                        Do you want to proceed?
                        </v-card-text>

                        <v-card-actions class="justify-center">
                            <v-btn dark color="red accent-4" @click="decisionDialog=false">NO</v-btn>
                            <v-btn dark color="blue darken-4" @click="changeEvent()">YES</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card>
            </v-dialog>
            <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.message" />
            <Progress v-model="progress.show" :message="progress.message" />
        </v-app>
    </div>    
</template>

<script>
import firebase from "firebase";
import {db} from '../main';
import { mapGetters, mapState } from "vuex";
import moment from 'moment';
import { setTimeout } from 'timers';
import _ from 'lodash';
import Progress from '../extras/Progress.vue'
import Snackbar from '../extras/Snackbar.vue'
export default {
    components: {
        Snackbar,
        Progress
    },
    data: () => ({
        branch: "",
        date: moment().utcOffset('+0800').toISOString().substr(0, 10),
        maindate: moment().utcOffset('+0800').toISOString().substr(0, 10),
        time: {
            "from":[],
            "to": [],
            "overAllTime": [],
        },
        branchId: "",
        selectdate: false,
        lists: [],
        event: "",
        timeTo: "",
        timeFrom: "",
        remarks: "",
        timeStampId: null,
        allowedDates: null,
        customers: [],
        headers: [
            { text: 'Event',  align: 'left', sortable: false, value: 'event'},
            { text: 'Date',align: 'left', value: 'date' },
            { text: 'Time', align: 'center',value: 'To' },
            { text: 'Remarks', align: 'left', value: 'remarks' },
            { text: 'Status', align: 'left', value: 'status' },
        ],
        forApprovalHeader: [
            { text: 'Event',  align: 'left', sortable: false, value: 'event'},
            { text: 'Date',align: 'left', value: 'date' },
            { text: 'Time', align: 'center',value: 'To' },
            { text: 'Remarks', align: 'left', value: 'remarks' },
            { text: 'Status', align: 'left', value: 'status' },
            { text: 'Creation By', align: 'left', value: 'requester' },
            { text: 'Creation Date', align: 'left', value: 'createdDate' },
            { text: 'Action', align: 'center', value: 'name' },
        ],
        search: "",
        level: "",
        approver: [],
        status: "",
        requester: "",
        showPending: false,
        forApproval: [],
        approved: [],
        decisionDialog: false,
        decisionTitle: "",
        decisionBody: "",
        forChangeEvent: {},
        type: "",
        timeHold: [],
        approvers: [],
        reasons: [],
        snackbar: {
            responseMessage: "",
            show: false,
            type: "success"
        },
        progress: {
            message: "",
            show: false,
        },
    }),

    methods : {
        showSnackbarMessage(message, success = true) {
            this.snackbar.type = success ? "success" : "error"
            this.snackbar.message = message
            this.snackbar.show = true
        },
        showProgress(message) {
            this.progress.message = message
            this.progress.show = true
        },
        stopProgress() {
            this.progress.show = false
        },
        async getAssign() {
            let self = this
            self.showProgress("Loading Data...")
            await firebase.auth().onAuthStateChanged(async function(user) {
                await db.collection("Users"+self.$stage).doc(user.uid)
                .get().then(function(doc) {
                    self.branch = doc.data().assign
                    self.requester = doc.data().email
                    self.branchId = doc.data().assignId
                }).then(async function() {
                    await db.collection("branchUsers"+self.$stage).doc(self.requester)
                    .get().then(function(res) {
                        self.level = res.data().role
                    }).then(async function() {
                        await self.fetchRoles()
                        await self.fetchApprovers()
                        await self.fetchEvents()
                    })
                })
            })
        },
        async fetchApprovers() {
            let self = this
            self.approvers = []
            await db.collection("branchUsers"+self.$stage)
            .where("branchId","==",self.branchId)
            .where("status","==","active")
            .where("role","==","Branch Manager")
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc){
                    self.approvers.push(doc.data().email)
                })
            }).then(async function(){
                await db.collection("HO-Users"+self.$stage).where("status","==","active")
                .get().then(function(querySnapshot){
                    querySnapshot.forEach(function(doc){
                        self.approvers.push(doc.data().email)
                    })
                }).then(function(){
                    self.approvers = _.uniq(self.approvers)
                }).catch(function(error) {
                    console.log(error)
                })
            }).catch(function(error){
                console.log(error)
            })
        },
        async fetchReasons(){
            let self = this
            self.reasons = []

            await db.collection("Settings"+self.$stage).doc("Rejection")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc){
                    self.reasons.push(doc.data().reason)
                })
            }).catch(function(error){
                console.log(error)
                self.showSnackbarMessage("Error fetching reasons", false)
            })
        },
        async fetchRoles() {
            let self = this
            let items = []
            let count = 0
            await db.collection("Settings"+self.$stage).doc("Roles")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    items.push(doc.data())
                })
            }).then(function(){
                items.forEach(function(res) {
                    if (res.level>1) {
                        self.approver.push(res.role)
                    }
                    count ++
                    if(count === items.length) {
                        if (self.approver.includes(self.level)){
                            self.status = "approved"
                        } else {
                            self.status = "pending"
                        }
                    }
                })
            })
        },
        async fetchEvents() {
            let self = this
            await db.collection("Events"+self.$stage)
            .where("branchId","==",self.branchId)
            .onSnapshot(function(querySnapshot) {
                self.lists = []
                self.forApproval = []
                self.approved = []
                self.showProgress("Loading Data...")
                querySnapshot.forEach(function(doc) {
                    self.lists.push(doc.data())
                    if (doc.data().status === "pending") {
                        self.forApproval.push(doc.data())
                    } else if(doc.data().status === "approved") {
                        self.approved.push(doc.data())
                    }
                })
                setTimeout(() => {
                    self.stopProgress()
                    self.lists = (_.sortBy(self.lists, 'date')).reverse()
                }, 500)
            })
        },
        async clear () {
            let self = this
            self.event = ""
            self.timeTo = ""
            self.timeFrom = ""
            self.remarks = ""
            self.maindate= moment().utcOffset('+0800').toISOString().substr(0, 10),
            await self.fetchTimeSelection()
        },
        async setAdminCalendar(){
            let self = this
            let from = self.time.overAllTime.indexOf(self.timeFrom)
            let to = self.time.overAllTime.indexOf(self.timeTo)
            self.timeStampId = new Date().getTime().toString()
            self.timeHold = []

            if (self.timeTo != "" && self.timeFrom != "" && self.event != "" && self.remarks != "" && self.status != "") {
                self.showProgress("Saving...")
                self.timeHold = self.time.overAllTime.splice( from , to-from + 1)
                await db.collection("Events"+self.$stage).doc(self.timeStampId)
                .set({
                    "branch": self.branch,
                    "branchId": self.branchId,
                    "Id": self.timeStampId,
                    "event": self.event,
                    "date": self.maindate,
                    "timeHold": self.timeHold,
                    "remarks": self.remarks,
                    "To": self.timeTo,
                    "From": self.timeFrom,
                    "status": self.status,
                    "requester": self.requester,
                    "createdDate": moment().format('MMMM Do YYYY, h:mm:ss a'),
                    "modifiedDate" : "",
                    "approvedBy": "",
                }).then(async function(doc) {
                    if (self.status === "approved") {
                        await self.checkCustomersAppointment(self.maindate,self.timeHold)
                    } else {
                        await self.approverNotification()
                        self.stopProgress()
                        self.clear()
                        self.showSnackbarMessage("Saved", true)
                    }
                })
            } else if (self.timeTo == "" || self.timeFrom == ""){
                self.showSnackbarMessage("Please pick a time", false)
            } else if (self.event == "" || self.remarks == ""){
                self.showSnackbarMessage("Please input event and remarks", false)
            } else if (self.status == ""){
                self.showSnackbarMessage("Error fetching status", false)
            }
        },
        async checkCustomersAppointment(date,timeHold) {
            let self = this
            let allCustomers = []
            let count = 0
            await db.collection("ServiceBooking"+self.$stage)
            .where("branchId","==", self.branchId)
            .where("appointmentDate","==",date)
            .where("status","==","Waiting")
            .get().then(function(snapshot) {
                snapshot.forEach(function(res) {
                    allCustomers.push(res.data())
                })
            }).then(function() {
                if (allCustomers.length > 0) {
                    allCustomers.forEach(function(data) {
                        if (timeHold.includes(data.appointmentTime)) {
                            self.customers.push(data)
                        }
                        count ++
                        if (count === allCustomers.length) {
                            if (self.customers.length > 0) {
                                self.notifications()
                            } else {
                                self.showSnackbarMessage("Saved", true)
                                self.decisionDialog = false
                                self.showPending = false
                                self.stopProgress()
                                self.clear()
                            }
                        }
                    })
                } else {
                    self.showSnackbarMessage("Saved", true)
                    self.decisionDialog = false
                    self.showPending = false
                    self.stopProgress()
                    self.clear()
                }
            })
        },
        decision(data,type) {
            let self = this
            if (type === "approved") {
                self.decisionTitle = "Are you sure you want to Approve this event ?"
                self.decisionBody = "You are about to Approved this event in the list, all affected appointment will received notification."
                self.decisionDialog = true
                self.forChangeEvent = data
                self.type = type
            } else {
                self.decisionTitle = "Are you sure you want to Reject this event ?"
                self.decisionBody = "You are about to Reject this event in the list. Branch appointment time will still open."
                self.decisionDialog = true
                self.forChangeEvent = data
                self.type = type
            } 
        },
        async changeEvent() {
            let self = this
            self.showProgress("Updating...")
            await db.collection("Events"+self.$stage).doc(self.forChangeEvent.Id)
            .update({
                modifiedDate: moment().format('MMMM Do YYYY, h:mm:ss a'),
                status: self.type,
                approvedBy: self.requester,
            }).then(function() {
                if (self.type === "approved") {
                    self.remarks = self.forChangeEvent.remarks
                    self.checkCustomersAppointment(self.forChangeEvent.date,self.forChangeEvent.timeHold)
                } else {
                    self.stopProgress()
                    self.clear()
                    self.showSnackbarMessage("Saved", true)
                    window.location.reload()
                }
            })
        },
        approverNotification(){
            let self = this
            if (self.status !== "approved") {
                let message = "Hi Approvers,"+ "\n\nA user " + self.requester + " has created a branch event and would like your approval." + "\n\nFor Branch Approver please go to " +"Calendar Management".link(self.$branchUrl +'/calendar-management') + "." +"\nFor Head Office Approver please go to " +"Events".link(self.$adminUrl +'/branch-event') + "\n\nService Scheduler Team"

                let emailMessage = message.replace(/(\r\n|\n|\r)/gm, "<br>")
            
                if (self.approvers.length > 0) {
                    self.approvers.forEach(async function(res){
                        let load = {
                            "receiver" : res,
                            "subject" : "For Approval of Branch Event",
                            "html" : emailMessage
                        }
                        await self.$axios.post(self.$mailerUrl, load).then(response => {
                            console.log("Notification sent")
                        }).catch(function(error) {
                            console.error(error)
                        })
                    })
                } 
            }
        },
        notifications() {
            let self = this
            let message = ""
            let source = ""
            let urlSms = self.$smsUrl
            self.$axios.defaults.headers.common['Authorization'] = self.$smsAuthorization
            self.$axios.defaults.headers.common['Content-Type'] = self.$contentType

            if (self.branch.includes("Transcycle")) {
                source = "Transcycle"
            } else if (self.branch.includes("Powercycle")) {
                source = "Powercycle" 
            }

            if (self.customers.length>0) {
                self.showProgress("Sending Notification...")
                self.customers.forEach(async function(info) {
                    let message = "Dear " + info.userDetails.firstName + ",\n\nThank you for booking a service appointment with us! We are sorry to inform you that your schedule for service on "+ info.formatedDate + " at "+ info.branch + " with Control #: " + info.transactionId + " is unavailable." + "\n\nYou can always set another schedule at "+ self.$clientUrl +" or please feel free to visit any of our branches."

                    let mailerBody = {
                        "receiver" : info.userDetails.email,
                        "subject" : "Your Appointment Slot is No Longer Available",
                        "message" : message
                    }

                    let smsBody = {
                        "source": source,
                        "destination": `63${info.userDetails.mobileNumber}`,
                        "text": message,
                    }

                    await self.$axios.post(self.$mailerUrl, mailerBody).then(function(){
                        console.log(mailerBody)
                    }).catch(error => console.log(error))

                    await self.$axios.post(urlSms, smsBody).then(response => { 
                        db.collection("ServiceBooking"+self.$stage).doc(info.transactionId)
                        .update({
                            status: "Cancelled",
                            tag: "BranchEvent"
                        }).then(function() {
                            setTimeout(() => {
                                self.decisionDialog = false
                                self.showPending = false
                                self.stopProgress()
                                self.clear()
                                self.showSnackbarMessage("Saved, notifiation to customer sent", true)
                                window.location.reload()
                            }, 1000)
                        }).catch(function(error) {
                            console.log("Error updating document")
                        })
                    }).catch(function(error){
                        console.log("Failed sending Notifications")
                    })
                })
            } else {
                setTimeout(() => {
                    self.stopProgress()
                    self.clear()
                    self.showSnackbarMessage("Saved! No affected customer.", true)
                    window.location.reload()
                }, 1000)
            }
        },
        async fetchTimeSelection(){
            let self = this
            let count = 0
            let timesChecker = []
            await db.collection("Settings"+self.$stage).doc("Schedule")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    timesChecker.push(doc.data().time)
                    count ++

                    if (count === querySnapshot.docs.length) {
                        timesChecker.sort(function (timeA, timeB) {
                            return new Date('1970/01/01 ' + timeA) - new Date('1970/01/01 ' + timeB)
                        })
                        self.time = {
                            "from": timesChecker,
                            "to": timesChecker,
                            "overAllTime": timesChecker
                        }
                    }
                })
            }).catch(function(error) {
                console.log(error)
            })
        },
    },

    async mounted() {
        await this.getAssign()
        await this.fetchTimeSelection()
        await this.fetchReasons()
    },

    computed: {
        computedDateFormattedMomentjs () {
            return this.maindate ? moment(this.maindate).format('dddd, MMMM Do YYYY') : ''
        },
    },  
}
</script>

<style scoped>
    .tile {
        border: 1px solid;
        border-color: rgba(0, 102, 255, 0.459);
    };
</style>